module.exports = [
	[
		[
			9,
			1
		],
		{
			"name": "HD 242908",
			"spectralType": "O5"
		}
	],
	[
		[
			12.5,
			1.8660254037844386
		],
		{
			"name": "HD 215835",
			"spectralType": "O5.5"
		}
	],
	[
		[
			8,
			1
		],
		{
			"name": "HD  12993",
			"spectralType": "O6.5"
		}
	],
	[
		[
			11,
			1
		],
		{
			"name": "HD  35619",
			"spectralType": "O7"
		}
	],
	[
		[
			9.5,
			1.8660254037844386
		],
		{
			"name": "HD  44811",
			"spectralType": "O7.5"
		}
	],
	[
		[
			7,
			1
		],
		{
			"name": "HD 242935",
			"spectralType": "O8"
		}
	],
	[
		[
			6,
			1
		],
		{
			"name": "HD 236894",
			"spectralType": "O8"
		}
	],
	[
		[
			13,
			2.732050807568877
		],
		{
			"name": "HD  17520",
			"spectralType": "O9"
		}
	],
	[
		[
			4.5,
			1.8660254037844386
		],
		{
			"name": "HD  12323",
			"spectralType": "O9"
		}
	],
	[
		[
			11,
			1
		],
		{
			"name": "BD+62 249",
			"spectralType": "O9.5"
		}
	],
	[
		[
			4,
			1
		],
		{
			"name": "HD 158659",
			"spectralType": "B0"
		}
	],
	[
		[
			8,
			1
		],
		{
			"name": "HD 237007",
			"spectralType": "B0"
		}
	],
	[
		[
			4.5,
			1.8660254037844386
		],
		{
			"name": "HD  35215",
			"spectralType": "B1.5"
		}
	],
	[
		[
			6,
			2.732050807568877
		],
		{
			"name": "HD  37767",
			"spectralType": "B3"
		}
	],
	[
		[
			1,
			1
		],
		{
			"name": "FEIGE  40",
			"spectralType": "B4"
		}
	],
	[
		[
			11.5,
			3.598076211353316
		],
		{
			"name": "HD 240344",
			"spectralType": "B4"
		}
	],
	[
		[
			7.5,
			3.598076211353316
		],
		{
			"name": "HD  30584",
			"spectralType": "B6"
		}
	],
	[
		[
			2,
			1
		],
		{
			"name": "O    1015",
			"spectralType": "B8"
		}
	],
	[
		[
			2,
			1
		],
		{
			"name": "HD 116608",
			"spectralType": "A1"
		}
	],
	[
		[
			1,
			1
		],
		{
			"name": "FEIGE  41",
			"spectralType": "A1"
		}
	],
	[
		[
			3.5,
			1.8660254037844386
		],
		{
			"name": "HD 124320",
			"spectralType": "A2"
		}
	],
	[
		[
			1,
			1
		],
		{
			"name": "FEIGE  28",
			"spectralType": "A2"
		}
	],
	[
		[
			5.5,
			3.598076211353316
		],
		{
			"name": "HD 190785",
			"spectralType": "A2"
		}
	],
	[
		[
			4,
			2.732050807568877
		],
		{
			"name": "HD 221741",
			"spectralType": "A3"
		}
	],
	[
		[
			3,
			1
		],
		{
			"name": "HD   9547",
			"spectralType": "A5"
		}
	],
	[
		[
			4,
			2.732050807568877
		],
		{
			"name": "HD  21619",
			"spectralType": "A6"
		}
	],
	[
		[
			5,
			4.464101615137754
		],
		{
			"name": "HD  23863",
			"spectralType": "A7"
		}
	],
	[
		[
			3.5,
			1.8660254037844386
		],
		{
			"name": "HD 111525",
			"spectralType": "A7"
		}
	],
	[
		[
			2.5,
			1.8660254037844386
		],
		{
			"name": "HD   9972",
			"spectralType": "A8"
		}
	],
	[
		[
			5,
			4.464101615137754
		],
		{
			"name": "HD  23733",
			"spectralType": "A9"
		}
	],
	[
		[
			3.5,
			3.598076211353316
		],
		{
			"name": "HD  10032",
			"spectralType": "F0"
		}
	],
	[
		[
			2,
			2.732050807568877
		],
		{
			"name": "HZ    948",
			"spectralType": "F3"
		}
	],
	[
		[
			1,
			2.732050807568877
		],
		{
			"name": "HD  23511",
			"spectralType": "F4"
		}
	],
	[
		[
			1,
			2.732050807568877
		],
		{
			"name": "HZ    227",
			"spectralType": "F5"
		}
	],
	[
		[
			1,
			2.732050807568877
		],
		{
			"name": "SAO 57199",
			"spectralType": "F6"
		}
	],
	[
		[
			4,
			4.464101615137754
		],
		{
			"name": "HD  24189",
			"spectralType": "F6"
		}
	],
	[
		[
			2.5,
			3.598076211353316
		],
		{
			"name": "HD   5702",
			"spectralType": "F7"
		}
	],
	[
		[
			2.5,
			3.598076211353316
		],
		{
			"name": "HD 107132",
			"spectralType": "F7"
		}
	],
	[
		[
			2.5,
			3.598076211353316
		],
		{
			"name": "HD 107214",
			"spectralType": "F7"
		}
	],
	[
		[
			2.5,
			3.598076211353316
		],
		{
			"name": "HD   6111",
			"spectralType": "F8"
		}
	],
	[
		[
			2.5,
			5.330127018922193
		],
		{
			"name": "HD  31084",
			"spectralType": "F9"
		}
	],
	[
		[
			2,
			2.732050807568877
		],
		{
			"name": "HD 107399",
			"spectralType": "F9"
		}
	],
	[
		[
			4,
			6.196152422706632
		],
		{
			"name": "HD  28099",
			"spectralType": "G0"
		}
	],
	[
		[
			3.5,
			5.330127018922193
		],
		{
			"name": "HD  17647",
			"spectralType": "G1"
		}
	],
	[
		[
			3,
			6.196152422706632
		],
		{
			"name": "HD  66171",
			"spectralType": "G2"
		}
	],
	[
		[
			1,
			1
		],
		{
			"name": "BD+581199",
			"spectralType": "G3"
		}
	],
	[
		[
			1.5,
			1.8660254037844386
		],
		{
			"name": "TR A   14",
			"spectralType": "G4"
		}
	],
	[
		[
			3.5,
			5.330127018922193
		],
		{
			"name": "HD  22193",
			"spectralType": "G6"
		}
	],
	[
		[
			4.5,
			7.06217782649107
		],
		{
			"name": "HD  27685",
			"spectralType": "G7"
		}
	],
	[
		[
			6,
			7.928203230275509
		],
		{
			"name": "HD  33278",
			"spectralType": "G9"
		}
	],
	[
		[
			2,
			4.464101615137754
		],
		{
			"name": "HD  29050",
			"spectralType": "G9"
		}
	],
	[
		[
			1.5,
			5.330127018922193
		],
		{
			"name": "HD  23524",
			"spectralType": "K0"
		}
	],
	[
		[
			1.5,
			5.330127018922193
		],
		{
			"name": "HD   5351",
			"spectralType": "K4"
		}
	],
	[
		[
			3.5,
			10.526279441628825
		],
		{
			"name": "SAO 76803",
			"spectralType": "K5"
		}
	],
	[
		[
			1,
			6.196152422706632
		],
		{
			"name": "HD 260655",
			"spectralType": "M0"
		}
	],
	[
		[
			1,
			6.196152422706632
		],
		{
			"name": "BD+63 137",
			"spectralType": "M1"
		}
	],
	[
		[
			1,
			4.464101615137754
		],
		{
			"name": "YALE 1755",
			"spectralType": "M5"
		}
	],
	[
		[
			3.5,
			3.598076211353316
		],
		{
			"name": "HD  13505",
			"spectralType": "F0"
		}
	],
	[
		[
			3.5,
			3.598076211353316
		],
		{
			"name": "HD  83140",
			"spectralType": "F3"
		}
	],
	[
		[
			4.5,
			5.330127018922193
		],
		{
			"name": "HD  78277",
			"spectralType": "G2"
		}
	],
	[
		[
			4.5,
			7.06217782649107
		],
		{
			"name": "HD  70178",
			"spectralType": "G5"
		}
	],
	[
		[
			11,
			1
		],
		{
			"name": "HD 227018",
			"spectralType": "O6.5"
		}
	],
	[
		[
			12,
			1
		],
		{
			"name": "SAO 11810",
			"spectralType": "O7.5"
		}
	],
	[
		[
			12,
			1
		],
		{
			"name": "HD 191978",
			"spectralType": "O8.5"
		}
	],
	[
		[
			13,
			7.928203230275509
		],
		{
			"name": "HD  16429",
			"spectralType": "O9.5"
		}
	],
	[
		[
			5.5,
			1.8660254037844386
		],
		{
			"name": "HD  13494",
			"spectralType": "B1"
		}
	],
	[
		[
			5.5,
			1.8660254037844386
		],
		{
			"name": "HD  12727",
			"spectralType": "B2"
		}
	],
	[
		[
			6.5,
			1.8660254037844386
		],
		{
			"name": "O    2311",
			"spectralType": "B2"
		}
	],
	[
		[
			9,
			2.732050807568877
		],
		{
			"name": "SAO 11885",
			"spectralType": "B2.5"
		}
	],
	[
		[
			9.5,
			3.598076211353316
		],
		{
			"name": "HD 166125",
			"spectralType": "B3"
		}
	],
	[
		[
			5.5,
			1.8660254037844386
		],
		{
			"name": "HD  39136",
			"spectralType": "B4"
		}
	],
	[
		[
			4,
			1
		],
		{
			"name": "HD  56183",
			"spectralType": "B4"
		}
	],
	[
		[
			7.5,
			3.598076211353316
		],
		{
			"name": "HD 256413",
			"spectralType": "B5"
		}
	],
	[
		[
			3,
			1
		],
		{
			"name": "BD+61 339",
			"spectralType": "B7"
		}
	],
	[
		[
			7.5,
			3.598076211353316
		],
		{
			"name": "HD  28696",
			"spectralType": "B8"
		}
	],
	[
		[
			6,
			2.732050807568877
		],
		{
			"name": "HD  20023",
			"spectralType": "B9"
		}
	],
	[
		[
			5.5,
			3.598076211353316
		],
		{
			"name": "HD  12027",
			"spectralType": "A3"
		}
	],
	[
		[
			4.5,
			3.598076211353316
		],
		{
			"name": "HD 240296",
			"spectralType": "A6"
		}
	],
	[
		[
			5.5,
			3.598076211353316
		],
		{
			"name": "HD  12161",
			"spectralType": "A8"
		}
	],
	[
		[
			2.5,
			1.8660254037844386
		],
		{
			"name": "HD  64191",
			"spectralType": "F0"
		}
	],
	[
		[
			2.5,
			3.598076211353316
		],
		{
			"name": "HD   5211",
			"spectralType": "F4"
		}
	],
	[
		[
			1,
			1
		],
		{
			"name": "BD+61 367",
			"spectralType": "F5"
		}
	],
	[
		[
			3.5,
			3.598076211353316
		],
		{
			"name": "HD  56030",
			"spectralType": "F6"
		}
	],
	[
		[
			1.5,
			3.598076211353316
		],
		{
			"name": "SAO 20603",
			"spectralType": "F7"
		}
	],
	[
		[
			2.5,
			3.598076211353316
		],
		{
			"name": "HD   9979",
			"spectralType": "F8"
		}
	],
	[
		[
			5,
			6.196152422706632
		],
		{
			"name": "HD  15866",
			"spectralType": "G0"
		}
	],
	[
		[
			1,
			1
		],
		{
			"name": "BD+302347",
			"spectralType": "G0"
		}
	],
	[
		[
			4.5,
			7.06217782649107
		],
		{
			"name": "HD  25894",
			"spectralType": "G2"
		}
	],
	[
		[
			4.5,
			8.794228634059948
		],
		{
			"name": "HD   2506",
			"spectralType": "G4"
		}
	],
	[
		[
			1,
			2.732050807568877
		],
		{
			"name": "BD+281885",
			"spectralType": "G5"
		}
	],
	[
		[
			1.5,
			1.8660254037844386
		],
		{
			"name": "HD 112872",
			"spectralType": "G6"
		}
	],
	[
		[
			5,
			11.392304845413264
		],
		{
			"name": "HD  26514",
			"spectralType": "G6"
		}
	],
	[
		[
			4,
			7.928203230275509
		],
		{
			"name": "HD  29883",
			"spectralType": "G6"
		}
	],
	[
		[
			2.5,
			7.06217782649107
		],
		{
			"name": "HD 245389",
			"spectralType": "G8"
		}
	],
	[
		[
			1.5,
			3.598076211353316
		],
		{
			"name": "SAO 55155",
			"spectralType": "G9"
		}
	],
	[
		[
			2,
			4.464101615137754
		],
		{
			"name": "SAO 55164",
			"spectralType": "K0"
		}
	],
	[
		[
			2,
			6.196152422706632
		],
		{
			"name": "HD  33506",
			"spectralType": "K2"
		}
	],
	[
		[
			1,
			4.464101615137754
		],
		{
			"name": "SAO 77849",
			"spectralType": "K2"
		}
	],
	[
		[
			6.5,
			10.526279441628825
		],
		{
			"name": "HD  26946",
			"spectralType": "K3"
		}
	],
	[
		[
			6,
			11.392304845413264
		],
		{
			"name": "HD  21110",
			"spectralType": "K4"
		}
	],
	[
		[
			2.5,
			8.794228634059948
		],
		{
			"name": "SAO 21753",
			"spectralType": "K7"
		}
	],
	[
		[
			1,
			4.464101615137754
		],
		{
			"name": "SAO 63349",
			"spectralType": "M3"
		}
	],
	[
		[
			1.5,
			8.794228634059948
		],
		{
			"name": "HD 110964",
			"spectralType": "M4"
		}
	],
	[
		[
			1,
			7.928203230275509
		],
		{
			"name": "SAO 62808",
			"spectralType": "M5"
		}
	],
	[
		[
			12.5,
			8.794228634059948
		],
		{
			"name": "HD  14357",
			"spectralType": "B2"
		}
	],
	[
		[
			9,
			2.732050807568877
		],
		{
			"name": "BD-144956",
			"spectralType": "B2"
		}
	],
	[
		[
			1,
			2.732050807568877
		],
		{
			"name": "BD-003227",
			"spectralType": "F5"
		}
	],
	[
		[
			7,
			9.660254037844386
		],
		{
			"name": "HD 249384",
			"spectralType": "G8"
		}
	],
	[
		[
			1,
			2.732050807568877
		],
		{
			"name": "HD 250368",
			"spectralType": "G9"
		}
	],
	[
		[
			2,
			11.392304845413264
		],
		{
			"name": "BD+191947",
			"spectralType": "M3"
		}
	],
	[
		[
			1,
			11.392304845413264
		],
		{
			"name": "BD+361963",
			"spectralType": "M7"
		}
	],
	[
		[
			13,
			6.196152422706632
		],
		{
			"name": "BD-114586",
			"spectralType": "O8"
		}
	],
	[
		[
			13.5,
			1.8660254037844386
		],
		{
			"name": "HD 225160",
			"spectralType": "O8"
		}
	],
	[
		[
			12.5,
			3.598076211353316
		],
		{
			"name": "HD  16808",
			"spectralType": "B0.5"
		}
	],
	[
		[
			13.5,
			7.06217782649107
		],
		{
			"name": "HD 167451",
			"spectralType": "B0.5"
		}
	],
	[
		[
			11.5,
			5.330127018922193
		],
		{
			"name": "BD-145030",
			"spectralType": "B1.5"
		}
	],
	[
		[
			10.5,
			3.598076211353316
		],
		{
			"name": "HD 209678",
			"spectralType": "B2"
		}
	],
	[
		[
			9.5,
			3.598076211353316
		],
		{
			"name": "SAO 20899",
			"spectralType": "B3"
		}
	],
	[
		[
			11.5,
			7.06217782649107
		],
		{
			"name": "HD 192832",
			"spectralType": "B5"
		}
	],
	[
		[
			8.5,
			5.330127018922193
		],
		{
			"name": "BD+61 220",
			"spectralType": "B7"
		}
	],
	[
		[
			11.5,
			7.06217782649107
		],
		{
			"name": "HD  17145",
			"spectralType": "B8"
		}
	],
	[
		[
			7,
			4.464101615137754
		],
		{
			"name": "HD 209900",
			"spectralType": "A0"
		}
	],
	[
		[
			9.5,
			5.330127018922193
		],
		{
			"name": "SAO 11344",
			"spectralType": "A0"
		}
	],
	[
		[
			9,
			6.196152422706632
		],
		{
			"name": "SAO 12149",
			"spectralType": "A1"
		}
	],
	[
		[
			6.5,
			5.330127018922193
		],
		{
			"name": "SAO 87716",
			"spectralType": "A3"
		}
	],
	[
		[
			9.5,
			7.06217782649107
		],
		{
			"name": "SAO 12096",
			"spectralType": "A4"
		}
	],
	[
		[
			10.5,
			8.794228634059948
		],
		{
			"name": "HD   9167",
			"spectralType": "A7"
		}
	],
	[
		[
			8,
			6.196152422706632
		],
		{
			"name": "HD    842",
			"spectralType": "A9"
		}
	],
	[
		[
			4,
			2.732050807568877
		],
		{
			"name": "SAO 37370",
			"spectralType": "F0"
		}
	],
	[
		[
			5.5,
			3.598076211353316
		],
		{
			"name": "BD+58 204",
			"spectralType": "F2"
		}
	],
	[
		[
			9,
			6.196152422706632
		],
		{
			"name": "HD  12842",
			"spectralType": "F3"
		}
	],
	[
		[
			7,
			6.196152422706632
		],
		{
			"name": "SAO 21536",
			"spectralType": "F4"
		}
	],
	[
		[
			11,
			9.660254037844386
		],
		{
			"name": "HD   9973",
			"spectralType": "F5"
		}
	],
	[
		[
			10,
			7.928203230275509
		],
		{
			"name": "HD   8992",
			"spectralType": "F6"
		}
	],
	[
		[
			6.5,
			7.06217782649107
		],
		{
			"name": "HD 187428",
			"spectralType": "F8"
		}
	],
	[
		[
			8,
			9.660254037844386
		],
		{
			"name": "HD  25361",
			"spectralType": "G0"
		}
	],
	[
		[
			5,
			7.928203230275509
		],
		{
			"name": "SAO 21446",
			"spectralType": "G1"
		}
	],
	[
		[
			3,
			7.928203230275509
		],
		{
			"name": "BD+56  84",
			"spectralType": "G2"
		}
	],
	[
		[
			4.5,
			7.06217782649107
		],
		{
			"name": "HD 191010",
			"spectralType": "G3"
		}
	],
	[
		[
			10,
			11.392304845413264
		],
		{
			"name": "HD 187299",
			"spectralType": "G5"
		}
	],
	[
		[
			3.5,
			8.794228634059948
		],
		{
			"name": "HD 186293",
			"spectralType": "K0"
		}
	],
	[
		[
			4.5,
			8.794228634059948
		],
		{
			"name": "SAO 37325",
			"spectralType": "K1"
		}
	],
	[
		[
			4.5,
			10.526279441628825
		],
		{
			"name": "HD   1069",
			"spectralType": "K2"
		}
	],
	[
		[
			6,
			11.392304845413264
		],
		{
			"name": "HD   1400",
			"spectralType": "K5"
		}
	],
	[
		[
			8,
			11.392304845413264
		],
		{
			"name": "HD  14330",
			"spectralType": "M1"
		}
	],
	[
		[
			9,
			11.392304845413264
		],
		{
			"name": "HD  13136",
			"spectralType": "M2"
		}
	],
	[
		[
			3.5,
			5.330127018922193
		],
		{
			"name": "HD  94028",
			"spectralType": "MPF4"
		}
	],
	[
		[
			1,
			1
		],
		{
			"name": "SAO102986",
			"spectralType": "MPF7"
		}
	],
	[
		[
			1,
			7.928203230275509
		],
		{
			"name": "SAO 81292",
			"spectralType": "M4.5"
		}
	],
	[
		[
			13.5,
			3.598076211353316
		],
		{
			"name": "HD  16691",
			"spectralType": "O5"
		}
	],
	[
		[
			13,
			4.464101615137754
		],
		{
			"name": "HD    108",
			"spectralType": "O6"
		}
	],
	[
		[
			13,
			11.392304845413264
		],
		{
			"name": "BD+404220",
			"spectralType": "O7"
		}
	],
	[
		[
			13,
			9.660254037844386
		],
		{
			"name": "HD  13256",
			"spectralType": "B1"
		}
	],
	[
		[
			13,
			7.928203230275509
		],
		{
			"name": "HD  50064",
			"spectralType": "B1"
		}
	],
	[
		[
			7,
			2.732050807568877
		],
		{
			"name": "BD+51 710",
			"spectralType": "B5"
		}
	]
];


/*****************
 ** WEBPACK FOOTER
 ** ./data/result.json
 ** module id = 217
 ** module chunks = 0
 **/